import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, SparklesIcon, ShieldIcon, TrendingUpIcon, HeartPulseIcon, TrophyIcon, CheckIcon } from 'lucide-react';
export function TomesSection() {
  const tomes = [{
    icon: SearchIcon,
    number: 1,
    title: 'Diagnóstico de Puertas Abiertas',
    resuelve: 'La confusión de no saber por dónde empezar',
    bullets: ['Identificar qué está drenando tu energía', 'Hacer un mapa claro de prioridades', 'Saber exactamente qué atacar primero'],
    paraQue: 'Dejes de dar vueltas y empieces con claridad total',
    value: '$8.000'
  }, {
    icon: SparklesIcon,
    number: 2,
    title: 'Protocolo de Limpieza',
    resuelve: 'La acumulación de desorden físico, mental y emocional',
    bullets: ['Cerrar fugas de energía que no veías', 'Hacer una limpieza profunda guiada', 'Sentir alivio real desde la primera semana'],
    paraQue: 'Tu hogar deje de ser parte del problema y empiece a ser parte de la solución',
    value: '$8.000'
  }, {
    icon: ShieldIcon,
    number: 3,
    title: 'Blindaje del Hogar',
    resuelve: 'La sensación de vulnerabilidad y ambiente pesado',
    bullets: ['Crear un espacio protegido y en paz', 'Poner límites sin conflicto', 'Mantener el ambiente limpio de forma sostenida'],
    paraQue: 'Entrar a tu casa sea sinónimo de calma, no de tensión',
    value: '$8.000'
  }, {
    icon: TrendingUpIcon,
    number: 4,
    title: 'Desbloqueo Financiero',
    resuelve: "Las fugas de dinero y la sensación de 'nunca alcanza'",
    bullets: ['Detectar y cerrar fugas invisibles', 'Ordenar tus finanzas con un sistema simple', 'Cambiar tu relación con el dinero'],
    paraQue: 'El dinero deje de ser fuente de angustia y empiece a fluir con orden',
    value: '$8.000'
  }, {
    icon: HeartPulseIcon,
    number: 5,
    title: 'Salud y Vitalidad',
    resuelve: 'El insomnio, la ansiedad y el agotamiento crónico',
    bullets: ['Dormir mejor con un protocolo concreto', 'Bajar la ansiedad sin depender de pastillas', 'Recuperar energía física y mental'],
    paraQue: 'Te levantes con ganas, no con la sensación de que ya perdiste el día',
    value: '$8.000'
  }, {
    icon: TrophyIcon,
    number: 6,
    title: 'Sostenimiento de la Victoria',
    resuelve: 'El patrón de empezar bien y volver a caer',
    bullets: ['Automatizar los hábitos que te sostienen', 'Tener un plan para los días difíciles', 'Consolidar los cambios sin esfuerzo heroico'],
    paraQue: 'Lo que lograste no se pierda — y cada semana sea mejor que la anterior',
    value: '$8.000'
  }];
  return <section className="py-12 md:py-32 px-4 bg-secondary-bg relative" data-id="element-369">
      <div className="max-w-7xl mx-auto" data-id="element-370">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-8 md:mb-16" data-id="element-371">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-372">
            Qué Recibís: 6 Tomos de Transformación Guiada
          </h2>
          <p className="text-text-secondary font-body-serif text-base md:text-xl" data-id="element-373">
            Material directo al grano. Sin relleno. Listo para aplicar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-374">
          {tomes.map((tomo, idx) => {
          const Icon = tomo.icon;
          return <div key={idx} className="bg-card-bg rounded-xl md:rounded-2xl p-4 md:p-6 border border-border-gold shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 relative overflow-hidden flex flex-col h-full" data-id="element-375">
                {/* Gold top accent bar */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-gold" data-id="element-376" />

                {/* Value badge */}
                <div className="absolute top-3 right-3" data-id="element-377">
                  <span className="text-[10px] md:text-xs font-bold text-text-muted line-through bg-primary-bg px-2 py-0.5 rounded-full" data-id="element-378">
                    Valor {tomo.value}
                  </span>
                </div>

                <div className="flex items-center gap-3 mb-3 md:mb-4 pr-16" data-id="element-379">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gold/10 flex items-center justify-center shrink-0" data-id="element-380">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-gold" data-id="element-381" />
                  </div>
                  <div data-id="element-382">
                    <span className="text-gold font-bold text-[10px] md:text-xs tracking-wider uppercase block" data-id="element-383">
                      Tomo {tomo.number}
                    </span>
                    <h3 className="font-heading text-sm md:text-base font-bold text-text-primary leading-tight" data-id="element-384">
                      {tomo.title}
                    </h3>
                  </div>
                </div>

                <div className="space-y-2.5 flex-grow flex flex-col" data-id="element-385">
                  <div className="bg-primary-bg p-2.5 rounded-lg border-l-2 border-gold" data-id="element-386">
                    <p className="text-xs md:text-sm text-text-secondary" data-id="element-387">
                      <span className="font-bold text-text-primary" data-id="element-388">
                        Resuelve:
                      </span>{' '}
                      {tomo.resuelve}
                    </p>
                  </div>

                  <ul className="space-y-1.5 flex-grow" data-id="element-389">
                    {tomo.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start text-xs md:text-sm text-text-primary font-medium" data-id="element-390">
                        <CheckIcon className="w-3.5 h-3.5 text-gold shrink-0 mt-0.5 mr-1.5" data-id="element-391" />
                        <span data-id="element-392">{bullet}</span>
                      </li>)}
                  </ul>

                  <div className="pt-2.5 mt-2.5 border-t border-border-gold" data-id="element-393">
                    <p className="text-xs md:text-sm font-body-serif italic text-text-secondary" data-id="element-394">
                      <span className="font-bold not-italic text-gold" data-id="element-395">
                        Para que:
                      </span>{' '}
                      {tomo.paraQue}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}